import { API_BASE_URL } from "./apiConfig";
import { logApiContext } from "../config/apiBaseUrl";

const API_URL = `${API_BASE_URL}/api/vehicles`; // ajusta si usas proxy o ruta base distinta
const logRequest = (action, url) =>
  logApiContext(`vehicleService:${action}`, { url, API_URL });

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const parseError = async (response) => {
  try {
    const data = await response.json();
    return data?.message;
  } catch {
    try {
      return await response.text();
    } catch {
      return null;
    }
  }
};

const handleResponse = async (response, defaultMessage) => {
  if (!response.ok) {
    const msg = (await parseError(response)) || defaultMessage;
    throw new Error(msg);
  }
  return response.json();
};

export const createVehicle = async (vehicleData) => {
  try {
    const url = `${API_URL}/create`;
    logRequest("createVehicle", url);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: JSON.stringify(vehicleData),
    });

    return await handleResponse(response, "Error al crear vehículo");
  } catch (error) {
    console.error("Error al crear vehículo:", error);
    throw error;
  }
};

const fetchVehicles = async (url) => {
  logRequest("fetchVehicles", url);
  const response = await fetch(url, {
    headers: authHeader(),
  });
  return handleResponse(response, "Error al obtener vehículos");
};

export const getVehiclesByUserId = async (userId) =>
  fetchVehicles(`${API_URL}/by-user/${userId}`);

export const getVehiclesByDriverId = async (driverId) =>
  fetchVehicles(`${API_URL}/by-driver/${driverId}`);

export const getVehiclesByBoss = async () =>
  fetchVehicles(`${API_URL}/by-boss`);

export const getVehiclesForCurrentUser = async ({
  userId,
  driverId,
  userType,
} = {}) => {
  if (driverId) return getVehiclesByDriverId(driverId);
  if (userType === "Boss") return getVehiclesByBoss();
  if (userId) return getVehiclesByUserId(userId);
  return [];
};

export const getVehicleById = async (vehicleId) => {
  try {
    const url = `${API_URL}/${vehicleId}`;
    logRequest("getVehicleById", url);
    const response = await fetch(url, {
      headers: authHeader(),
    });

    return await handleResponse(response, "Error al obtener vehículo");
  } catch (error) {
    console.error("Error al obtener vehículo:", error);
    throw error;
  }
};

export const updateVehicle = async (vehicleId, payload) => {
  try {
    const url = `${API_URL}/${vehicleId}`;
    logRequest("updateVehicle", url);
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: JSON.stringify(payload),
    });
    return await handleResponse(response, "Error al actualizar vehículo");
  } catch (error) {
    console.error("Error al actualizar vehículo:", error);
    throw error;
  }
};

export const deleteVehicle = async (vehicleId) => {
  const url = `${API_URL}/${vehicleId}`;
  logRequest("deleteVehicle", url);
  const response = await fetch(url, {
    method: "DELETE",
    headers: authHeader(),
  });
  return handleResponse(response, "Error al eliminar vehículo");
};
